import { useCallback } from "react";
import { VIMEO_VIDEO_LIST_LIMIT } from "../../config/const";
import { ProgramStore } from "../../stores/ProgramStore";
import { MediaFolder } from "../../types";

interface UseHandleMediaFolderChangeProps {
  programStore: ProgramStore;
}
export const useHandleMediaFolderChange = ({
  programStore,
}: UseHandleMediaFolderChangeProps) => {
  return useCallback(
    async (folderId: MediaFolder["projectId"]) => {
      programStore.setMediaList([]);
      programStore.setMediaListTotal(0);
      await programStore.fetchMediaList(folderId, 1, VIMEO_VIDEO_LIST_LIMIT);
    },
    [programStore]
  );
};
